import React from 'react';
import PropTypes from 'prop-types';
import NoImage from '../../SiteDetailsPage/imagePlaceholder1.png';

const CarouselSiteImage = ({
  image = '',
  imageID = -1,
  isActive = false,
  children = null,
  heightStyle = '',
  isModal = false,
}) => {
  return (
    <div
      className={`w-full ${heightStyle} flex-shrink-0 transition-opacity duration-500 ${
        isActive ? 'opacity-100' : 'hidden absolute top-0 left-0'
      }`}
    >
      <img
        src={image || NoImage}
        className={`w-full h-full ${
          isModal ? 'object-contain' : 'object-cover rounded-lg'
        }`}
        style={{ aspectRatio: '16/9' }}
        alt={`${imageID} slide`}
      />
      {children}
    </div>
  );
};

CarouselSiteImage.propTypes = {
  image: PropTypes.string,
  imageID: PropTypes.number,
  isActive: PropTypes.bool,
  children: PropTypes.node,
  heightStyle: PropTypes.string,
  isModal: PropTypes.bool,
};

export default CarouselSiteImage;
